import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { Client } from "@/Common/Api/Client";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { UpdateClickableTextOrderNumberRequest } from "../../Models/Requests/UpdateClickableTextOrderNumberRequest";
import { ClickableTextEditor } from "./ClickableTextEditor";
import { ClickableTextFooter } from "./ClickableTextFooter";

import "./ClickableTextPanel.css";
import iconStyle from "./ClickableTextPanel.module.scss";

import DownArrow from "@/Common/Components/ClickableText/_images/down-arrow.svg";
import PlusIcon from "@/Common/Components/ClickableText/_images/plus_icon.svg";
import UpArrow from "@/Common/Components/ClickableText/_images/up-arrow.svg";

interface IClickableTextPanelProps {
    context: string;
    inputElementId: string;
    onCloseOperation?: number;
    onCloseEvent?: any;
    cssClass: string;
    employeeId?: string;
    isHorizontalAligned?: boolean;
    doNotAdjustPosition?: boolean;
    // id of the html component on which the clickable text container will be top+left aligned (clickable text will match top , and its right side will match the left side of component)
    horizontalAlignementElementId?: string;
    reduceHeight?: boolean;
    leftAlign?: boolean;
    maxLength?: number;
    hasResponsiveHeight?: boolean;
    cssStyle?: React.CSSProperties;
    useLocalTextEditor?: boolean;
    dataCy?: string;
}

class ClickableTextPanelState {
    public Tabs: ClickableTextItem[];
    public ContentLoaded: boolean;
    public CategorySearchQ: string;
    public showLocalTextEditor: boolean = false;
    public isEditMode: boolean = false;
}

class ClickableTextPanel extends React.Component<IClickableTextPanelProps, ClickableTextPanelState> {
    private client: Client;
    private inputReference: JQuery;
    private containerId: string;
    private keyboardOut: boolean;
    private isMobileDevice: boolean;
    private onLoadlickableTexts: ClickableTextItem[] = [];
    private localDispatcherReferenceId: string;

    private horizontalAlignFunctionRef = (): void => this.setHorizontalDisplayCoordinates(); // must be an arrow function, since it's passed directly to window.[add|remove]EventListener

    constructor(props: IClickableTextPanelProps) {
        super(props);
        this.keyboardOut = false;
        this.client = new Client();
        this.containerId = GuidHelper.NewGuid();
        this.isMobileDevice = CurrentDevice.Any();

        this.setAsReadOnly();
        this.state = this.getInitialState();
    }

    public render(): JSX.Element {
        let style: React.CSSProperties = {};
        if (this.props.isHorizontalAligned)
            style.opacity = 0;

        if (this.props.leftAlign)
            style.left = 0;

        if (this.props.cssStyle) {
            const cssStyle: React.CSSProperties = this.props.cssStyle;
            style = { ...style, ...cssStyle };
        }

        const clickableTextClass = `${this.props.cssClass} clickable-text-component`;
        const responsiveHeightClassName: string = this.props.hasResponsiveHeight ? "responsive-height" : "";

        return (
            <>
                <div
                    id={this.containerId}
                    className={clickableTextClass}
                    onClick={e => this.containerClick(e)}
                    style={style}
                >
                    <div className="categories column" data-cy={this.props.dataCy ? `${this.props.dataCy}-categoriesColumn` : null}>
                        <div className="txt-wp">
                            <div className="search-field-and-add-button">
                                <div className="search-field">
                                    <div className="gf">
                                        <span className="glyphicon glyphicon-search" />
                                    </div>
                                    <input type="text" value={this.state.CategorySearchQ} onChange={e => this.filterCategories(e)} placeholder={cacheStore.GetString("SearchLabel")} />
                                </div>
                                <button
                                    className={`btn btn-primary ${iconStyle.buttonIconContainer}`}
                                    data-cy={this.props.dataCy ? `${this.props.dataCy}-plus` : null}
                                    onClick={() => this.showCreateTabUI()}
                                >
                                    <div className={iconStyle.icon}>
                                        <PlusIcon />
                                    </div>
                                </button>
                            </div>

                            <div className={`overflow-control ${this.props.reduceHeight ? "half-height" : ""} ${responsiveHeightClassName}`}>
                                <ul className="left-view">
                                    {this.state.Tabs.map((t, idx: number) => {
                                        if (t.Visible === false) return null;
                                        if (t.Selected === true) {
                                            return <li key={idx + "___cat"} className="active"><a>{t.TabName}</a></li>;
                                        }
                                        else {
                                            return <li onClick={() => this.selectTab(t)} key={idx + "___cat"}><a>{t.TabName}</a></li>;
                                        }
                                    })}
                                </ul>
                            </div>
                        </div>
                        <div className="ftr">
                            <div className="arrow-footer">
                                <button
                                    id="upArrow"
                                    className={`btn btn-primary ${iconStyle.buttonIconContainer}`}
                                    onClick={() => this.orderTabNames(-1)}
                                >
                                    <div className={iconStyle.icon}>
                                        <UpArrow />
                                    </div>
                                </button>
                                <button
                                    id="downArrow"
                                    className="btn btn-primary"
                                    onClick={() => this.orderTabNames(1)}
                                >
                                    <div className={iconStyle.icon}>
                                        <DownArrow />
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="clickable-text column" data-cy={this.props.dataCy ? `${this.props.dataCy}-textColumn` : null}>
                        <div className="txt-wp">
                            <div className={`overflow-control ${this.props.reduceHeight ? "half-height" : ""} ${responsiveHeightClassName}`} style={{ whiteSpace: "pre" }}>
                                <ul className="clickable-text-list">
                                    {this.getSelectedTabFromState().ClickableContentItems.map((s: string, idx: number) => (
                                        <li key={idx + "___cli"} style={{ flexWrap: "wrap" }}>
                                            <div className="flex-container" style={{ justifyContent: "flex-start", display: "flex" }}>
                                                <div style={{ width: "10px" }}>
                                                    <span className="dot" />
                                                </div>
                                                <div style={{ width: "10px" }}>
                                                    {this.splitClickableTextItems(s).map((sp: string, idx2: number) => (
                                                        <a key={"individual_link_" + idx2} style={{ marginRight: "5px", lineHeight: "15px", minHeight: "35px", marginBottom: "6px" }} onClick={this.appendTextToControl.bind(this, sp)}>
                                                            <span>{sp}</span>
                                                        </a>
                                                    ))}
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="ftr">
                            <div className="ftl-cnt">
                                <ClickableTextFooter
                                    inputElementId={this.props.inputElementId}
                                    isFromClickableTextEditor={false}
                                />
                                <div className="buttons-flx">
                                    {CurrentDevice.iOS() &&
                                        <div onClick={e => this.toggleKeyboard(e)} className="keyboard-button push-right-5" />
                                    }
                                    <button
                                        className="btn btn-primary push-right-5"
                                        data-cy={this.props.dataCy ? `${this.props.dataCy}-modify` : null}
                                        onClick={() => this.editTab()}
                                        disabled={IsNullOrWhiteSpace(this.getSelectedTabFromState()?.TabName)}
                                    >
                                        <span>{cacheStore.GetString("ModifyLabel")}</span>
                                    </button>
                                    <button className="btn btn-default" onClick={() => this.callCloseEvents()} data-cy={this.props.dataCy ? `${this.props.dataCy}-close` : null}>
                                        <span>{cacheStore.GetString("CloseLabel")}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showLocalTextEditor && (
                    <div className={iconStyle.clickableTextEditorContainer}>
                        <ClickableTextEditor
                            context={this.props.context}
                            editMode={this.state.isEditMode}
                            className={iconStyle.clickableTextEditor}
                            tabName={this.state.isEditMode ? this.getSelectedTabFromState().TabName : ""}
                            onCloseCallback={() => this.setState({ showLocalTextEditor: false })}
                        />
                    </div>
                )}
            </>
        );
    }

    private getSelectedTabFromState(): ClickableTextItem {
        if (!this.state.ContentLoaded) return this.emptyTab();
        let selected = this.state.Tabs.filter((t: ClickableTextItem) => t.Selected === true)[0];
        if (typeof selected === "undefined") { return this.emptyTab(); }
        else return selected;
    }

    private compareOrderAndUpdate(): void {
        const sortedDataOnload = this.sortTabNames(this.onLoadlickableTexts);
        const sortStateData = this.sortTabNames(this.state.Tabs);
        if (sortedDataOnload.length != sortStateData.length) { return; }
        let toUpdateOrderNumber: ClickableTextItem[] = [];
        for (let i = 0; i < sortedDataOnload.length; i++) {
            const orderChanged =
                sortedDataOnload[i].TabName === sortStateData[i].TabName
                && sortedDataOnload[i].TabOrderIndex !== sortStateData[i].TabOrderIndex
                && sortedDataOnload[i].TabOrderIndex !== null
                && sortStateData[i].TabOrderIndex !== null;

            if (orderChanged)
                toUpdateOrderNumber.push(sortStateData[i]);
        }
        if (typeof toUpdateOrderNumber === "undefined" || !toUpdateOrderNumber.any()) { return; }
        let data: UpdateClickableTextOrderNumberRequest[] = [];

        toUpdateOrderNumber.forEach(element => {
            let item = new UpdateClickableTextOrderNumberRequest();
            item.ItemId = element.ItemId;
            item.TabOrderIndex = element.TabOrderIndex;
            data.push(item);
        });

        this.client.Post(
            ServerOperations.Server.Employee_UpdateClickableTextItemOrderNumber,
            {
                ClickableItems: data
            },
            () => { }
            ,
            error => console.error(error)
        );
    }

    private sortTabNames(isToSort: ClickableTextItem[]): ClickableTextItem[] {
        const sortedData = isToSort.sort((a, b) => {
            if (a.TabName.toLowerCase() > b.TabName.toLowerCase())
                return 1;
            else
                return -1;
        });
        return sortedData;
    }

    private orderTabNames(offset: number): void {
        let tabs = this.state.Tabs;

        // get selected tab
        const selectedIndex = tabs.findIndex(tab => tab.Selected);
        const selected = tabs[selectedIndex];
        if (IsNullOrUndefined(selected?.TabOrderIndex))
            return;

        // get tab to swap with
        const swapWithIndex = selectedIndex + offset;
        if (swapWithIndex < 0 || swapWithIndex >= tabs.length)
            return;
        const swapWith = tabs[swapWithIndex];

        // swap order values
        [swapWith.TabOrderIndex, selected.TabOrderIndex] = [selected.TabOrderIndex, swapWith.TabOrderIndex];

        // swap list order
        tabs = MyleHelper.CloneObject(tabs);
        [tabs[selectedIndex], tabs[swapWithIndex]] = [tabs[swapWithIndex], tabs[selectedIndex]];

        // save
        this.setState({ Tabs: tabs });
    }

    private emptyTab(): ClickableTextItem {
        let q = new ClickableTextItem;
        q.ItemId = "";
        q.CreatedOn = "";
        q.ClickableContent = "";
        q.ClickableContentItems = [];
        q.Context = "";
        q.Language = "";
        q.TabName = "";
        q.TabOrderIndex = 0;
        q.Selected = false;
        q.Visible = false;
        return q;
    }

    public componentDidMount(): void {
        this.loadContentAsync();
        this.listenToDispatcher();
        window.addEventListener("resize", this.horizontalAlignFunctionRef);
    }

    public componentDidUpdate(): void {
        this.setHorizontalDisplayCoordinates();
    }

    public componentWillUnmount(): void {
        this.compareOrderAndUpdate();
        if (this.isMobileDevice) {
            this.inputReference.removeAttr("readonly");
        }
        MainComponentStateDispatcher.unregister(this.localDispatcherReferenceId);
        window.removeEventListener("resize", this.horizontalAlignFunctionRef);
    }

    private loadContentAsync(): void {
        if (this.client == null) {
            throw new TypeError("invalid operation");
        }

        this.client.Post(
            ServerOperations.Server.Employee_GetClickableText,
            {
                EmployeeId: (this.props.employeeId != null ? this.props.employeeId : sessionStore.individualContactId),
                Context: this.props.context,
                LanguageCode: sessionStore.userLanguageCode
            },
            response => {
                this.loadContentComplete(response);
            },
            error => console.error(error)
        );
    }

    private loadContentComplete(data: any): void {
        let list: ClickableTextItem[] = data.ClickableItems;
        let s = new ClickableTextPanelState();
        s.Tabs = [];
        for (let i = 0; i < list.length; i++) {
            let t = list[i];
            t.Selected = i === 0;
            t.Visible = true;
            s.Tabs.push(t);
        }

        this.onLoadlickableTexts = JSON.parse(JSON.stringify(list));
        s.ContentLoaded = true;

        this.setState(s);
    }

    private selectTab(tab: ClickableTextItem): void {
        let tabs = this.state.Tabs.map(t => {
            if (t.ItemId === tab.ItemId) { t.Selected = true; }
            else { t.Selected = false; }
            return t;
        });

        let s = new ClickableTextPanelState();
        s.Tabs = tabs;
        this.setState(s);
    }

    private filterCategories(e: React.ChangeEvent<HTMLInputElement>): void {
        let val: string = e.target.value;
        let idx = 0;
        let matchingTabs = this.state.Tabs.map(t => {
            if (val.trim() === "") { t.Visible = true; }
            else {
                let search = new RegExp(MyleHelper.EscapeRegExp(val), "i");
                t.Visible = search.test(t.TabName);
            }

            t.Selected = t.Visible && idx === 0;
            if (t.Visible) { idx++; }
            return t;
        });

        let s = new ClickableTextPanelState();
        s.CategorySearchQ = val;
        s.Tabs = matchingTabs;
        this.setState(s);
    }

    private appendTextToControl(value: string, e: React.MouseEvent): void {
        if (this.keyboardOut) {
            this.toggleKeyboard(e);
        }

        if (this.inputReference.length === 0) {
            return;
        }
        if (value !== "") {
            this.writeStringIntoControl(value, e.shiftKey);
        }
    }

    private writeStringIntoControl(str: string, onNewLine: boolean): void {
        let current: string = this.inputReference.val();

        let isEmpty = current.length === 0;
        let newValue = "";
        let parts = [];
        let cursorReturnPosition = 0;

        let p = 0;
        if (!isEmpty) {
            p = this.getCursorPosition(this.inputReference.get(0));
        }

        if (p > 0) {
            parts[0] = current.substring(0, p);
            parts[1] = current.substring(p);
        }

        if (parts.length === 2) { newValue = parts[0]; }
        else { newValue = current; }

        if (!isEmpty) {
            if (newValue.charAt(newValue.length - 1) != "\s" && newValue.length > 1) {
                newValue += " ";
            }
        }
        if (onNewLine) { newValue += "\n"; }

        if (str === "\n" || str === "\n\n") {
            newValue += str;
        }
        else {
            newValue += (str + " ");
        }

        if (parts.length == 2) {
            cursorReturnPosition = newValue.length;
            newValue += parts[1];
        }
        else {
            cursorReturnPosition = newValue.length;
        }

        if (this.props.maxLength)
            newValue = newValue.substr(0, this.props.maxLength);

        const input = document.getElementById(this.props.inputElementId);
        let propDescriptor: PropertyDescriptor = null;
        switch (input.nodeName) {
            case "INPUT":
                propDescriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value");
                break;
            case "TEXTAREA":
                propDescriptor = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value");
                break;
            default:
                throw new Error("The input element is not supported by ClickableTextPanel.");
        }
        propDescriptor.set.call(input, newValue);
        input.dispatchEvent(new Event("input", { bubbles: true }));

        this.inputReference.focus();

        if (!isEmpty) {
            this.setRange(this.inputReference.get(0), cursorReturnPosition);
        }
        else {
            this.setRange(this.inputReference.get(0), newValue.length);
        }
    }

    private splitClickableTextItems(txt: string): string[] {
        let q = txt.split(";");
        return q.filter((s: string) => s.trim() !== "").map((s: string) => s);
    }

    private getCursorPosition(elem): number {
        let d: any = document;
        let pos = 0;
        if ("selectionStart" in elem) {
            pos = elem.selectionStart;
        }
        else if ("selection" in d) {
            elem.focus();
            let Sel = d.selection.createRange();
            let SelLength = d.selection.createRange().text.length;
            Sel.moveStart("character", -elem.value.length);
            pos = Sel.text.length - SelLength;
        }
        return pos;
    }

    private showCreateTabUI(): void {
        this.compareOrderAndUpdate();

        if (this.props.useLocalTextEditor) {
            this.setState({
                showLocalTextEditor: true,
                isEditMode: false
            });
            return;
        }

        sessionStore.dispatchMain(
            LocalOperations.MainComponentViewOperations.DisplayCreateClickableText,
            { context: this.props.context }
        );
    }

    private editTab(): void {
        this.compareOrderAndUpdate();

        if (this.props.useLocalTextEditor) {
            this.setState({
                showLocalTextEditor: true,
                isEditMode: true
            });
            return;
        }

        sessionStore.dispatchMain(
            LocalOperations.MainComponentViewOperations.DisplayCreateClickableText,
            {
                context: this.props.context,
                isEdit: true,
                tabName: this.getSelectedTabFromState().TabName
            }
        );
    }

    private setRange(element, start: number, end?: number): void {
        if (end == null) {
            end = start;
        }
        if ("selectionStart" in element) {
            element.selectionStart = start;
            element.selectionEnd = end;
        }
        else if (element.setSelectionRange) {
            element.setSelectionRange(start, end);
        }
        else if (element.createTextRange) {
            let range = element.createTextRange();
            range.collapse(true);
            range.moveEnd("character", end);
            range.moveStart("character", start);
            range.select();
        }
    }

    /* listen to SPECIFIC local event on particular dispatcher  -- this is the necessary evil */
    private listenToDispatcher(): void {
        let self = this;
        this.localDispatcherReferenceId = MainComponentStateDispatcher.register((response: LocalEvent) => {
            switch (response.Operation) {
                case LocalOperations.MainComponentViewOperations.RefreshTabs: {
                    self.setAsReadOnly();
                    self.setState(self.getInitialState());
                    self.loadContentAsync();
                    break;
                }
                default:
                    break;
            }
        });
    }

    private setAsReadOnly(): void {
        this.inputReference = $("#" + this.props.inputElementId);
        if (this.isMobileDevice) {
            this.inputReference.attr("readonly", "readonly");
        }
    }

    private getInitialState(): ClickableTextPanelState {
        const initialState = new ClickableTextPanelState();
        initialState.ContentLoaded = false;
        initialState.showLocalTextEditor = false;
        initialState.CategorySearchQ = "";
        initialState.Tabs = [];
        return initialState;
    }

    private callCloseEvents(): void {
        if (this.props.onCloseOperation)
            sessionStore.dispatch(this.props.onCloseOperation);

        this.props.onCloseEvent?.();
    }

    private toggleKeyboard(e: React.MouseEvent): void {
        e.stopPropagation();
        if (this.isMobileDevice === false) return;
        if (this.keyboardOut === false) {
            this.keyboardOut = true;
            this.inputReference.removeAttr("readonly").focus();
        }
        else {
            this.keyboardOut = false;
            this.inputReference.attr("readonly", "readonly");
        }
    }

    private containerClick(e: React.MouseEvent): void {
        e.stopPropagation();

        if (this.isMobileDevice === false) return;
        if (this.keyboardOut === true) {
            this.inputReference.attr("readonly", "readonly");
        }
    }

    private setHorizontalDisplayCoordinates(): void {
        if (!this.props.isHorizontalAligned)
            return;

        if (IsNullOrWhiteSpace(this.props.horizontalAlignementElementId))
            return;

        // ensure we minimize the sidebar or the clickable panel will not fit
        sessionStore.dispatchAsync(LocalOperations.Sidebar.Close, {}, 50);

        // set the top element of clickable text to match the top of the reference element
        // set the left position equal to negative of value of width of clickable text popup
        let referenceElement = $("#" + this.props.horizontalAlignementElementId);
        let textHelperContainerElement = $(".text-helper-container");
        if (referenceElement && textHelperContainerElement) {
            if (!this.props.doNotAdjustPosition) {
                let referenceTopPosition = referenceElement.position().top;
                if (!referenceElement.hasClass("popup")) {
                    $("#" + this.containerId).css({ top: referenceTopPosition });
                    $("#" + this.containerId).css({ left: -textHelperContainerElement.width() });
                }
                else {
                    $("#" + this.containerId).css({ top: "0px" });
                    $("#" + this.containerId).css({ left: -$("#" + this.containerId).width() - 2 });
                }
            }

            $("#" + this.containerId).css({ opacity: 100 });
        }
    }
}

export { ClickableTextPanel, IClickableTextPanelProps };
